// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".S5VQGEciU5NKD0qmzUSD7g\\=\\={height:64px}html[dir] .S5VQGEciU5NKD0qmzUSD7g\\=\\={border-bottom:1px solid var(--dividerPrimary,#e1e1e1);background-color:var(--surfaceSecondary,#f8f8f8)}.S5VQGEciU5NKD0qmzUSD7g\\=\\=:after{content:\"\";display:block;height:100%;width:100%}html[dir] .S5VQGEciU5NKD0qmzUSD7g\\=\\=:after{background-repeat:no-repeat;background-image:linear-gradient(var(--skeletonBg,#eaeaea) 12px,transparent 0),linear-gradient(var(--skeletonBg,#eaeaea) 12px,transparent 0);background-size:85.5% 12px,50% 12px;background-position:16px 16px,16px 36px}", ""]);
// Exports
exports.locals = {
	"focusedOtherRollupPlaceholder": "S5VQGEciU5NKD0qmzUSD7g=="
};
module.exports = exports;
